import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { SITE_URL } from '../../utilities/seo';
import './styles.scss';

// items: [{ label, path }]; el último es la página actual (sin enlace).
// "Home" se agrega solo. También publica el schema BreadcrumbList.
const Breadcrumbs = ({ items, className = '' }) => {
    const trail = [{ label: 'Home', path: '/' }, ...items];

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: trail.map((item, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            name: item.label,
            ...(item.path && { item: SITE_URL + encodeURI(item.path) }),
        })),
    };

    return (
        <>
            <Helmet>
                <script type='application/ld+json'>{JSON.stringify(jsonLd)}</script>
            </Helmet>
            <nav aria-label='Breadcrumb' className={`breadcrumbs ${className}`}>
                <ol>
                    {trail.map((item, i) =>
                        i < trail.length - 1 ? (
                            <li key={i}>
                                <Link to={item.path}>{item.label}</Link>
                            </li>
                        ) : (
                            <li key={i} aria-current='page'>
                                {item.label}
                            </li>
                        )
                    )}
                </ol>
            </nav>
        </>
    );
};

export default Breadcrumbs;
